export const migrateToV8 = (state)=>{
    // V8 schema just adds a new entity - no need to migrate anything.
    return state;
};

//# sourceMappingURL=v8.js.map